// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_ezE","cls2":"ImpactHubModal-cls2_Anq ImpactHubModal-cls1_ezE"};